import './styles.scss'

import React, { Component } from 'react'
import PropTypes from 'prop-types'

export default class Close extends Component {
  static propTypes = {
    className: PropTypes.string,
    onClick: PropTypes.func.isRequired,
    color: PropTypes.string,
    style: PropTypes.object,
    pathStyle: PropTypes.object,
    inputMode: PropTypes.bool
  }

  render () {
    const { color, onClick, style, pathStyle, inputMode, className } = this.props

    return (
      <div
        className={`box exit-search-logo ${color}-background-exit ${inputMode ? 'with-border' : ''} ${className || ''}`}
        style={style}
        onClick={onClick}
      >
        <svg viewBox='0 0 40 40'>
          <path style={pathStyle} className='close-x' d='M 10,10 L 30,30 M 30,10 L 10,30' />
        </svg>
      </div>
    )
  }
}
